<template>
  <span class="product-aside-heading-market-exclusive">{{ label }}</span>
</template>

<script>

import { mapGetters } from "vuex";
import markets from "Assets/js/components/markets";

export default {
  computed: {
    ...mapGetters(['isB2B', 'currentMarket']),
    currentMarketLabel() {
      return markets.getCountryName(this.currentMarket) ?? this.currentMarket;
    },
    label() {
      return this.isB2B ?
        "This product does not ship to " + this.currentMarketLabel :
        "This product cannot be delivered to your selected market, please choose a different location.";
    }
  }
};
</script>
